<ngx-datatable
    [rows]="rows"
    [columnMode]="ColumnMode.force"
    [headerHeight]="50"
    [footerHeight]="50"
    rowHeight="auto"
    [limit]="5"
    [selected]="selected"
    [selectionType]="SelectionType.checkbox"
    (activate)="onActivate($event)"
    (select)="onSelect($event)"
>
    <ngx-datatable-column
        [width]="40"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template
            ngx-datatable-header-template
            let-value="value"
            let-allRowsSelected="allRowsSelected"
            let-selectFn="selectFn"
        >
            <div class="form-check">
                <input class="form-check-input" type="checkbox" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
            </div>
        </ng-template>
        <ng-template
            ngx-datatable-cell-template
            let-value="value"
            let-isSelected="isSelected"
            let-onCheckboxChangeFn="onCheckboxChangeFn"
        >
            <div class="form-check">
                <input class="form-check-input" type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
            </div>
        </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Name"></ngx-datatable-column>
    <ngx-datatable-column name="Gender"></ngx-datatable-column>
    <ngx-datatable-column name="Company"></ngx-datatable-column>
</ngx-datatable>